import React from 'react';
import ProfileForm from 'components/profileForm/ProfileForm';

function Profile() {
  return (
    <>
      <ProfileForm />
    </>
  );
}

export default Profile;
